import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import About from './components/About';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Grants from './components/Grants';
import Footer from './components/Footer';
import { SchemaOrg, localBusinessSchema, websiteSchema } from '../../utils/seo';

export default function HomePage() {
  return (
    <>
      <SchemaOrg type="LocalBusiness" data={localBusinessSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <Projects />
        <About />
        <Gallery />
        <Contact />
        <Grants />
        <Footer />
      </div>
    </>
  );
}
